<template>
  <section class="section-padding tw-w-full">
    <div class="tw-flex tw-w-full tw-flex-col lg:tw-flex-row lg:tw-gap-8">
      <div class="tw-w-full lg:tw-w-1/2">
        <Swiper
          :modules="[SwiperNavigation]"
          :pagination="true"
          :slides-per-view="1"
          :space-between="1"
          :loop="true"
          effect="fade"
          :clickable="true"
          :navigation="{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }"
          class="tw-w-full"
          @swiper="onSwiper"
        >
          <SwiperSlide v-for="(item, index) in primaryFivePhotos" :key="index" class="tw-relative tw-w-full">
            <library-image
              image-class="tw-w-full"
              :src="item.background"
              :h-raito="9"
              :w-ration="16"
              @click="(onClickedImage(item), toggleHeader())"
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            />
            <div v-if="property && property.medias" class="nc-first-image-overlay-item">
              <div
                style="
                  border-radius: var(--rounded-sm);
                  color: var(--c-text_primary);
                  background-color: var(--c-section_primary);
                "
                @click="(onClickedImage(image), toggleHeader())"
                class="tw-text-md tw-px-3 tw-py-2"
              >
                {{ index + 1 }}/{{ property.medias.length }}
              </div>
            </div>
          </SwiperSlide>
          <button
            v-if="property && property.medias && !property.is_locked"
            @click="(onClickedImage(primaryFivePhotos[0]), toggleHeader())"
            class="nc-gallery-button tw-hidden tw-border !tw-border-white !tw-bg-white !tw-px-5 !tw-py-3 lg:tw-inline-block"
          >
            VIEW GALLERY
          </button>
        </Swiper>
        <div class="tw-mt-5 tw-flex tw-w-full tw-justify-between">
          <div class="tw-relative tw-flex tw-w-full tw-items-start tw-justify-start tw-gap-3 lg:tw-justify-end">
            <div class="swiper-button-prev tw-group !tw-static !tw-m-0 tw-cursor-pointer tw-rounded">
              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                  cx="25"
                  cy="25"
                  r="24.5"
                  transform="matrix(0 -1 -1 0 50 50)"
                  stroke="#EEEEEE"
                  class="tw-duration-300 group-hover:tw-stroke-black"
                />
                <path
                  d="M17.6464 25.3536C17.4512 25.1583 17.4512 24.8417 17.6464 24.6464L20.8284 21.4645C21.0237 21.2692 21.3403 21.2692 21.5355 21.4645C21.7308 21.6597 21.7308 21.9763 21.5355 22.1716L18.7071 25L21.5355 27.8284C21.7308 28.0237 21.7308 28.3403 21.5355 28.5355C21.3403 28.7308 21.0237 28.7308 20.8284 28.5355L17.6464 25.3536ZM33 25.5L18 25.5L18 24.5L33 24.5L33 25.5Z"
                  fill="#171717"
                />
              </svg>
            </div>
            <div class="swiper-button-next tw-group !tw-static !tw-m-0 tw-cursor-pointer tw-rounded">
              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                  cx="25"
                  cy="25"
                  r="24.5"
                  transform="rotate(-90 25 25)"
                  stroke="#EEEEEE"
                  class="tw-duration-300 group-hover:tw-stroke-black"
                />
                <path
                  d="M32.3536 25.3536C32.5488 25.1583 32.5488 24.8417 32.3536 24.6464L29.1716 21.4645C28.9763 21.2692 28.6597 21.2692 28.4645 21.4645C28.2692 21.6597 28.2692 21.9763 28.4645 22.1716L31.2929 25L28.4645 27.8284C28.2692 28.0237 28.2692 28.3403 28.4645 28.5355C28.6597 28.7308 28.9763 28.7308 29.1716 28.5355L32.3536 25.3536ZM17 25.5L32 25.5L32 24.5L17 24.5L17 25.5Z"
                  fill="#171717"
                />
              </svg>
            </div>
          </div>
          <button
            v-if="property && property.medias && !property.is_locked"
            @click="(onClickedImage(primaryFivePhotos[0]), toggleHeader())"
            class="tw-w-full !tw-px-5 !tw-py-3 !tw-text-white lg:tw-hidden"
            style="background-color: var(--c-primary) !important"
          >
            VIEW GALLERY
          </button>
        </div>
      </div>
      <div
        class="tw-mt-6 tw-flex tw-w-full tw-flex-col lg:tw-mt-0 lg:tw-w-1/2 xl:tw-justify-between xl:tw-px-6 xl:tw-pb-20 xl:tw-pr-24"
      >
        <template v-if="!property.is_locked">
          <div class="tw-mt-6 tw-flex tw-flex-col lg:tw-mt-2">
            <h5 class="tw-mb-2" style="color: var(--c-text_secondary)">
              {{ property.price.type?.name || '\u00A0' }}
            </h5>
            <h3 style="color: var(--c-primary) !important">{{ property.price.price }}</h3>
          </div>
        </template>
        <template v-else-if="property.is_locked">
          <div class="tw-mt-6 tw-flex tw-flex-col">
            <h5>{{ preMarketBlurText || 'Pre-market Property' }}</h5>
          </div>
        </template>
        <div class="tw-mt-5 tw-pb-3 lg:tw-border-b">
          <h4 class="n-title-primary tw-line-clamp-3 tw-max-h-[94px] tw-min-h-[94px] group-hover:tw-underline">
            {{ property.advert_heading }}
          </h4>
        </div>
        <div class="tw-mt-5 tw-line-clamp-2 tw-flex tw-h-20 tw-flex-col tw-items-start tw-gap-2">
          <h5>Address:</h5>
          <p style="color: var(--c-text_primary) !important">{{ property.display_address }}</p>
        </div>
        <template v-if="!property.is_locked">
          <div class="tw-mt-6 tw-flex tw-min-h-[32px] tw-flex-wrap tw-gap-x-6 tw-gap-y-3">
            <div v-if="property.bedroom">
              <h5>Bedrooms</h5>
              <h3>{{ property.bedroom }}</h3>
            </div>
            <div v-if="property.bathroom">
              <h5>Bathrooms</h5>
              <h3>{{ property.bathroom }}</h3>
            </div>
            <div v-if="property.reception">
              <h5>Receptions</h5>
              <h3>{{ property.reception }}</h3>
            </div>
          </div>
          <button
            v-if="!property.is_locked"
            class="n-primary tw-mt-8 tw-w-full tw-self-start lg:tw-w-auto"
            @click="onSendLead()"
          >
            BOOK A VIEWING
          </button>
        </template>
        <template v-else-if="property.is_locked">
          <p class="tw-py-2">
            This is a pre-market property. You need to create an account and register to our property alerts in order to
            view it.
          </p>
          <div class="tw-mt-10 tw-flex tw-gap-x-2">
            <nuxt-link :to="routes.REGISTER" class="n-primary tw-w-fit" :external="true">Register</nuxt-link>
            <nuxt-link
              :to="`${routes.PROPERTY_DETAIL.replace(':propertyId', property.property_profile_id)}#login`"
              class="n-primary tw-w-fit"
              :external="true"
              >Login</nuxt-link
            >
          </div>
        </template>
      </div>
    </div>
  </section>
  <section class="tw-w-full tw-py-10" v-if="property?.featured_video?.mediaLink">
    <div class="container tw-max-w-[1200px]">
      <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-8">
        <h4 class="tw-text-center lg:tw-mb-6" style="font-size: 32px !important">View our Property Tour</h4>
        <library-iframe
          :src="property?.featured_video.mediaLink"
          :w-ratio="16"
          :h-ratio="9"
          :blur="imageBlurFilter"
          :pre-market-blur-text="preMarketBlurText"
        />
      </div>
    </div>
  </section>
  <section class="section-padding tw-w-full">
    <div class="container">
      <div class="tw-grid tw-w-full tw-grid-cols-12 md:tw-gap-x-10">
        <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
          <ul
            class="tw-flex tw-flex-col tw-flex-wrap tw-items-start tw-justify-start tw-gap-7 tw-border-b tw-border-t tw-py-8 md:tw-flex-row md:tw-gap-0 md:tw-border-b-0 md:tw-pb-0 md:tw-pt-10 lg:tw-gap-y-8"
          >
            <li v-for="(tab, tabIndex) in tabs" :key="`tab-${tabIndex}`" class="nav-item">
              <div
                :class="activeTab.name === tab.name ? 'active-tab' : ''"
                class="nav-link tw-cursor-pointer tw-border-b-2 tw-border-transparent md:tw-border-b-4 md:tw-border-[var(--c-border)] md:tw-px-4 md:tw-pb-4 lg:tw-px-6"
                data-toggle="tab"
                @click="
                  () => {
                    activeTab.name = tab.name;
                    activeTab.title = tab.title;
                  }
                "
              >
                <h4 class="tw-whitespace-nowrap tw-duration-300">{{ tab.title }}</h4>
              </div>
            </li>
          </ul>
          <div class="tab-content tw-my-6">
            <div v-show="activeTab.name === 'features'">
              <h3 class="tw-pb-4" style="font-size: 32px !important">{{ activeTab.title }}</h3>
              <div v-if="property?.features" class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                <div
                  v-for="(feature, index) in property.features"
                  :key="`property-feature-${index}`"
                  class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                >
                  <span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                        fill="var(--c-secondary)"
                      />
                    </svg>
                  </span>
                  <library-text :text="feature"> </library-text>
                </div>
              </div>
            </div>
            <div v-show="activeTab.name === 'property_information'" id="property_information" role="tabpanel">
              <h3 class="tw-pb-4" style="font-size: 32px !important">{{ activeTab.title }}</h3>
              <!-- amenties -->
              <library-text
                class="library-text"
                style="color: var(--c-text_secondary) !important"
                :html="property.description"
              />
              <div
                class="tw-mb-10 tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6"
              >
                <div
                  v-for="criteria in property.criteria_list"
                  :key="criteria.id"
                  class="tw-flex tw-gap-4 tw-p-4"
                  style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                >
                  <span v-if="criteria.title === 'Parking'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                        fill="var(--c-secondary)"
                      />
                    </svg>
                  </span>
                  <span v-else-if="criteria.title === 'Sewerage'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                        fill="var(--c-secondary)"
                      />
                    </svg>
                  </span>
                  <span v-else-if="criteria.title === 'Water'">
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                        fill="var(--c-secondary)"
                      />
                    </svg>
                  </span>
                  <span v-else>
                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_481_37820)">
                        <path
                          d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                          fill="var(--c-secondary)"
                        />
                        <path
                          d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                          fill="var(--c-secondary)"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_481_37820">
                          <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <div>
                    <h5 style="color: var(--c-text_secondary) !important">{{ criteria.title }}</h5>
                    <p style="color: var(--c-text_primary) !important">{{ criteria.value }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="activeTab.name === 'video_tour'" id="video_tour" role="tabpanel">
              <div v-if="featuredVideo">
                <h3 class="tw-pb-4" style="font-size: 32px !important">{{ activeTab.title }}</h3>
                <library-iframe
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                  :src="featuredVideo"
                  frameborder="0"
                  allowfullscreen
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                ></library-iframe>
              </div>
            </div>
            <div v-show="activeTab.name === 'floor_plan'" id="floor_plan" role="tabpanel">
              <h3 class="tw-pb-4" style="font-size: 32px !important">{{ activeTab.title }}</h3>
              <floor-plan :data="property.floor_plans" :component="component" />
            </div>
            <div
              v-if="property.map_position && property.map_position.lat && property.map_position.lng"
              v-show="activeTab.name === 'map'"
              id="map"
              role="tabpanel"
            >
              <h3 class="tw-pb-4" style="font-size: 32px !important">{{ activeTab.title }}</h3>
              <neuron-google-map
                v-model:map-center-position="property.map_position"
                :component="component"
                :marker-color="markerColor"
              />
            </div>
            <div v-show="activeTab.name === 'epc'" id="epc" role="tabpanel">
              <h3 class="tw-pb-4" style="font-size: 32px !important">{{ activeTab.title }}</h3>
              <epc :data="property.epcs" :component="component" />
            </div>
          </div>
        </div>
        <div class="tw-col-span-12 tw-pt-6 lg:tw-col-span-5 xl:tw-col-span-4">
          <div v-if="sidebarComponents && sidebarComponents.length" class="tw-flex tw-flex-col tw-gap-4">
            <div v-if="vars.viewingOptionsBool">
              <div
                class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
                :style="`background-color: var(--c-sidebar-card); border-radius: var(--rounded);`"
              >
                <h4>{{ vars.viewingOptionsTitleText }}</h4>
                <p v-if="vars.viewingOptionsDescriptionText">
                  {{ vars.viewingOptionsDescriptionText }}
                </p>
                <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
                  <button
                    v-if="featuredVideo"
                    :class="`n-${vars.viewingOptionsButton1TypeText} tw-w-fit`"
                    @click="onVidePopup()"
                  >
                    {{ vars.viewingOptionsButton1LabelText }}
                  </button>
                  <button :class="`n-${vars.viewingOptionsButton2TypeText} tw-w-fit`" @click="onSendLead()">
                    {{ vars.viewingOptionsButton2LabelText }}
                  </button>
                </div>
              </div>
            </div>
            <theme9-available-components-for-sidebar
              key="property-detail-sidebar"
              key-prefix="property-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </div>
      </div>
    </div>

    <full-screen-gallery
      v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias && !property.is_locked"
      v-model:active-media-index="activeMediaIndex"
      :component="component"
      :active-media="activeMedia"
      :count-of-medias="property.medias.length"
      @close="(closeLightbox(), toggleHeader())"
    />

    <popup :config="sendLeadPopupConfig" custom-width="800px">
      <template #content>
        <send-lead
          v-if="sendLeadPopupConfig.isActive"
          :property="property"
          @on-success="onSuccess"
          @close="sendLeadPopupConfig.isActive = false"
        />
      </template>
    </popup>

    <popup :config="videoPopupConfig" v-if="videoPopupConfig.videoPopupSrc" custom-width="500px" @close="stopVideo">
      <template #content>
        <div class="tw-relative tw-pt-6">
          <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
            <library-iframe
              class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
              :src="videoPopupConfig.videoPopupSrc"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
        </div>
      </template>
    </popup>

    <popup :config="successModalConfig" @close="onSuccessModalClosed()">
      <template #content>
        <success :text="successPopupText" />
      </template>
    </popup>
  </section>
</template>

<script lang="ts">
import { mapActions } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import FloorPlan from '~/components/common/FloorPlan.vue';
import NeuronGoogleMap from '~/components/common/NeuronGoogleMap.vue';
import Epc from '~/components/common/Epc.vue';
import NcSelect from '~/components/common/inputs/NcSelect.vue';
import NcInput from '~/components/common/inputs/NcInput.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import { useCoreStore } from '~/units/core/store';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import Popup from '~/components/common/popup/Popup.vue';
import PropertyDetailActions from '~/components/theme4/properties/PropertyDetailActions.vue';
import AvailableComponentsForSidebar from '~/components/theme9/AvailableComponentsForSidebar.vue';
import { FullScreenPopupMixin } from '~/units/core/mixins/fullScreenPopupMixin';
import { getImagesByCount } from '~/units/properties/store';
import { version } from 'vue';

export default defineNuxtComponent({
  name: 'Theme9PropertyDetail',
  components: {
    AvailableComponentsForSidebar,
    PropertyDetailActions,
    Popup,
    Success,
    SendLead,
    FullScreenGallery,
    NcButton,
    NcInput,
    NcSelect,
    Epc,
    NeuronGoogleMap,
    FloorPlan,
  },

  mixins: [ComponentMixin, PropertyMixin, FullScreenPopupMixin],

  data() {
    return {
      activeTab: { name: 'features', title: 'Features', is_visible: !!this.featuredVideo },
      activeTabV2: { name: 'features', title: 'FEATURES' },
      swiper: {},
      isScrolled: false,
      scrollThreshold: 0,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      videoPopupConfig: {
        isActive: false,
        videoPopupSrc: this.featuredVideo,
      },
    };
  },

  mounted() {
    this.setScrollThreshold();
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },

  computed: {
    tabs() {
      const tabs = [
        {
          name: 'features',
          title: 'Features',
          is_visible: !!this.property?.features,
        },
        {
          name: 'property_information',
          title: 'Property Info',
          is_visible: true,
        },
        {
          name: 'video_tour',
          title: 'Video Tour',
          is_visible: !!this.featuredVideo,
        },
        {
          name: 'floor_plan',
          title: 'Floor Plans',
          is_visible: !!this.property?.floor_plans?.length,
        },
        {
          name: 'map',
          title: 'Map',
          is_visible: !!this.property.map_position,
        },
        {
          name: 'epc',
          title: 'EPC',
          is_visible: !!this.property?.epcs?.length,
        },
      ];

      return tabs.filter((i) => i.is_visible);
    },

    tabsV2() {
      const tabs = [
        {
          name: 'cinematic_videography',
          title: 'CINEMATIC VIDEO',
          is_visible: !!this.featuredVideo,
        },
        {
          name: 'features',
          title: 'FEATURES',
          is_visible: !!this.property?.features,
        },
        {
          name: 'property_information',
          title: 'PROPERTY INFO',
          is_visible: true,
        },
        {
          name: 'floor_plan',
          title: 'FLOOR PLANS',
          is_visible: !!this.property?.floor_plans?.length,
        },
        {
          name: 'map',
          title: 'MAP',
          is_visible: !!this.property.map_position,
        },
        {
          name: 'epc',
          title: 'EPC',
          is_visible: !!this.property?.epcs?.length,
        },
        /*         {
          name: 'matterport_video',
          title: 'MATTERPORT VIDEO',
          is_visible: !!this.matterPort,
        }, */
      ];

      return tabs.filter((i) => i.is_visible);
    },

    markerColor() {
      return this.colors.primary || this.colors['--c-primary'] || '#000000';
    },

    ROUTES() {
      return ROUTES;
    },

    primaryFivePhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 5);
      }
      return [];
    },

    allPhotos() {
      if (this.property) {
        return getImagesByCount(this.property, Math.min(this.property.medias.length, 10));
      }
      return [];
    },

    primarySevenPhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 7);
      }
      return [];
    },

    sidebarComponents(): Component[] {
      if (this.currentPage && this.currentPage.sidebar) {
        return this.currentPage.sidebar;
      }
      return [];
    },

    isMortgageCalculatorVisible() {
      return !this.vars.isMortgageCalculatorHiddenNumber;
    },

    isStampDutyCalculatorVisible() {
      return !this.vars.isStampDutyCalculatorHiddenNumber;
    },

    isLetterPropertyCriteria() {
      return this.vars.isLetterPropertyCriteriaNumber;
    },

    featuredVideo() {
      const mediaLink = this.property?.featured_video?.mediaLink;
      if (mediaLink && mediaLink.includes('matterport')) {
        return null;
      }
      return mediaLink;
    },

    matterPort() {
      let mediaLink = this.property?.virtual_tour?.mediaLink;
      if (mediaLink && mediaLink.includes('youtu')) {
        return null;
      }
      if (mediaLink && mediaLink.startsWith('http://')) {
        mediaLink = mediaLink.replace('http://', 'https://');
      }
      return mediaLink;
    },
  },

  methods: {
    ...mapActions(useCoreStore, ['shareApi', 'openTab']),
    async onShared() {
      await this.shareApi({
        title: this.property?.advert_heading,
        text: this.property?.advert_heading,
        url: window.location.href,
      });
    },

    onSwiper(swiper: object) {
      this.swiper = swiper;
    },

    href(location) {
      this.activeTab.name = location;
    },

    handleScroll() {
      this.isScrolled = window.scrollY > this.scrollThreshold;
    },

    setScrollThreshold() {
      nextTick(() => {
        const ulElement = this.$refs.navTabs;
        if (ulElement) {
          this.scrollThreshold = ulElement.offsetTop - 90;
        }
      });
    },

    toggleHeader() {
      if (this.property.is_locked) {
        return;
      }
      document.body.classList.toggle('popup-open');
    },

    onVidePopup() {
      this.videoPopupConfig.isActive = !this.videoPopupConfig.isActive;
      this.videoPopupConfig.videoPopupSrc = this.featuredVideo;
    },

    stopVideo() {
      this.videoPopupConfig.videoPopupSrc = '';
    },
  },

  async setup(props: { component: Component }) {
    const store = usePropertiesStore();
    await store.fetchSingleProperty(props.component);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
});
</script>

<style scoped>
.active-tab {
  border-bottom-color: var(--c-primary);
}

.active-tab h4 {
  color: var(--c-primary) !important;
}

.nc-first-image-overlay-item {
  position: absolute;
  bottom: 0px;
  right: 0px;
  transform: translate(-50%, -50%);
  text-align: right;
  background-color: var(--white);
  color: var(--c-primary) !important;
  border-radius: 4px;
  cursor: pointer !important;
}

.nc-all-photos-button {
  position: absolute;
  bottom: 20px;
  left: 70px;
  padding: 10px;
  border-radius: 4px;
  background-color: var(--white);
  color: var(--nc-classic-black);
}

.nc-gallery-button {
  position: absolute;
  bottom: -15px;
  left: 90px;
  transform: translate(-50%, -50%);
  text-align: right;
  cursor: pointer !important;
  z-index: 10;
}

.swiper-button-next,
.swiper-button-prev {
  background-image: none !important;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  content: unset;
}
.swiper-button-next,
.swiper-button-prev {
  width: unset;
  height: unset;
}
</style>
